import { useMemo } from 'react'
import type { TemplateField } from 'shared/api/templateService'
import type { FieldDependencyInfo } from './useDatasourceDependencies'

interface UsePermitGeneralDetailsParams {
  generalFieldMap: Record<string, TemplateField | undefined>
  getFieldDependencyInfo: (field: TemplateField) => FieldDependencyInfo
}

export const usePermitGeneralDetails = ({
  generalFieldMap,
  getFieldDependencyInfo,
}: UsePermitGeneralDetailsParams) => {
  const workLocationField = generalFieldMap.WORKLOCATION
  const unitField = generalFieldMap.UNIT
  const projectNumberField = generalFieldMap.PROJNO
  const controllerField = generalFieldMap.CONTROLLER

  const controllerDependencyInfo = useMemo(() => {
    if (!controllerField) {
      return null
    }
    return getFieldDependencyInfo(controllerField)
  }, [controllerField, getFieldDependencyInfo])

  const controllerDependencyLabel = useMemo(() => {
    if (!controllerField || !controllerDependencyInfo?.config?.dependsOn) {
      return undefined
    }
    const dependsOnCode = controllerDependencyInfo.config.dependsOn
    const dependsOnField = generalFieldMap[dependsOnCode]
    return dependsOnField?.label || dependsOnCode
  }, [controllerField, controllerDependencyInfo, generalFieldMap])

  return {
    workLocationFieldId: workLocationField?.fieldId ?? '',
    unitField,
    unitFieldId: unitField?.fieldId ?? '',
    projectNumberField,
    controllerField,
    controllerDependencyInfo,
    controllerDependencyLabel,
  }
}
